const objeto9 = {
  titulo: `Objetos: Desestructuración de objetos`,
  problemas: [
    {
      codigo: 1,
      descripcion: `Las dos estructuras de datos fundamentales en JavaScript son los objetos y los arrays, ambos tienen una sintaxis definida para desestructurar sus elementos.
La desestructuración de objetos es una forma de extraer los elementos de un objeto y asignarlos a variables, para que sea más legible nuestro código.
La asignación desestructurante tiene la sintaxis:
<code>
const articulo1 = {
  codigo: 1,
  descripción: 'Papas',
  precio: 1.5
}

const { codigo, precio } = articulo1
console.log(codigo) // 1
console.log(precio) // 1.5
</code>
Hemos desempaquetado del objeto articulo1 las propiedades codigo y precio y las asignamos a variables primitivas codigo y precio. Son necesarios encerrar las variables entre llaves y que se llamen igual que las propiedades del objeto.
En un principio JavaScript permitía solo la siguiente sintaxis:
<code>
const codigo=articulo1.codigo
const precio=articulo1.precio
</code>`,
      programa: `const inmueble1 = {
  codigo: 1,
  direccion: 'Colon 120',
  precio: 1_000_000,
  habitaciones: 3,
  baños: 2,
  garage: true,
  superficie: 170,
  imagen: 'https://www.prueba.com/fotos/inmueble1.jpg',
  ubicacion: {
    lat: 10.12,
    lng: 8.12
  },
  tipo: 'Casa',
}

const { lat, lng } = inmueble1.ubicacion
console.log(lat)`,
      solucion: "10.12",
    }, {
      codigo: 2,
      descripcion: `La desestructuración se puede hacer en los parámetros de una función. Luego nos queda una sintaxis más sencilla y fundamentalmente más legible:`,
      programa: `const inmueble1 = {
  codigo: 1,
  direccion: 'Colon 120',
  precio: 1_000_000,
  habitaciones: 3,
  baños: 2,
  garage: true,
  superficie: 170,
  imagen: 'https://www.prueba.com/fotos/inmueble1.jpg',
  ubicacion: {
    lat: 10.12,
    lng: 8.12
  },
  tipo: 'Casa',
}

function mostrarUbicacion({ lat, lng }) {
  console.log(lat)
}

mostrarUbicacion(inmueble1.ubicacion)`,
      solucion: "10.12",
    }, {
      codigo: 3,
      descripcion: `Si intentamos desestructurar una atributo que no existe, luego nos retorna undefined.`,
      programa: `const persona1 = {
  nombre: 'Juan',
  apellido: 'Perez',
  estudios: 'Ingeniero'
}

const { edad } = persona1

console.log(edad)`,
      solucion: "undefined",
    }, {
      codigo: 4,
      descripcion: `Podemos asignar un valor por defecto, y en el caso que no exista el atributo en el objeto, se usará el valor por defecto.`,
      programa: `const persona1 = {
  nombre: 'Juan',
  apellido: 'Perez',
  edad: 20
}

const { documento = 1 } = persona1
console.log(documento)`,
      solucion: "1",
    }, {
      codigo: 5,
      descripcion: `Si por alguna razón necesitamos desestructurar y guardar el valor en una variable con distinto nombre que el atributo del objeto, debemos indicar luego del caracter ':' el nombre de la variable que queremos guardar el valor.`,
      programa: `const persona1 = {
  documento: 12345678,
  nombre: 'Juan',
  apellido: 'Perez',
  edad: 20
}

const { documento: dni } = persona1
console.log(dni)`,
      solucion: "12345678",
    }, {
      codigo: 6,
      descripcion: `Cuando hacemos una desestructuración de un objeto, podemos desestructurar en una variable un atributo y el resto en un objeto sin incluir las indicadas previamente.`,
      programa: `const articulo1 = {
  codigo: 1,
  descripcion: 'Sandia',
  precio: 12.55,
  stock: 10
}

const { codigo, ...articulo } = articulo1
console.log(articulo)`,
      solucion: "{ descripcion: 'Sandia', precio: 12.55, stock: 10 }",
    }, {
      codigo: 7,
      descripcion: ``,
      programa: `const empleado1 = {
  dni: 12345678,
  nombre: 'Juan',
  apellido: 'Perez',
  sueldos: [1000, 2000, 3000]
}

const { dni, apellido, ...datosEmpleado1 } = empleado1
console.log(datosEmpleado1)`,
      solucion: "{nombre:'Juan', sueldos: [ 1000, 2000, 3000 ] }",
    }, {
      codigo: 8,
      descripcion: ``,
      programa: `const inmueble1 = {
  codigo: 1,
  direccion: 'Colon 101',
  precio: 100000,
  tipo: 'casa',
  posicion: {
    lat: 6.44,
    lng: 2.35
  }
}

const { posicion, ...parteInmueble } = inmueble1
console.log(posicion)`,
      solucion: "{ lat: 6.44, lng: 2.35 }",
    }
  ]
}

export default objeto9;